import { twMerge } from "tailwind-merge";
import { IconsProps } from ".";

export const Camera = ({
  className = "text-primary",
  viewBox = "0 0 32 22",
  width = 32,
  height = 22,
  onClick,
}: IconsProps) => (
  <svg
    className={twMerge("cursor-pointer", className)}
    viewBox={viewBox}
    width={`${width}px`}
    height={`${height}px`}
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <title>Video</title>
    <path
      d="M21.1667 4V18H3.94444V4H21.1667ZM22.8889 0.5H2.22222C1.275 0.5 0.5 1.2875 0.5 2.25V19.75C0.5 20.7125 1.275 21.5 2.22222 21.5H22.8889C23.8361 21.5 24.6111 20.7125 24.6111 19.75V13.625L31.5 20.625V1.375L24.6111 8.375V2.25C24.6111 1.2875 23.8361 0.5 22.8889 0.5Z"
      fill="currentColor"
    />
  </svg>
);
